import React from 'react';

import QuotationsAvailabilityCard from './QuotationsAvailabilityCard';

const ConnectedQuotationsAvailabilityCard = props => (
  <QuotationsAvailabilityCard {...props} />
);

export default ConnectedQuotationsAvailabilityCard;
